import { FC } from 'react'

import { AttributeSection } from '@syconium/little-miss-figgy'

import { useOrganization } from '../../../../../../app/_providers/OrganizationProvider.client'
import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { EmbroideryService } from '../../../../../../containers/EmbroideryService'
import { hashPrefixed } from '../../../../../../lib/utils/color'
import { EmbroiderySectionTitle } from '../../../../../embroidery/EmbroiderySectionTitle'
import { EmbroiderySectionWrapper } from '../../../../../embroidery/EmbroiderySectionWrapper'
import { LogoSneakPeek } from '../../../../../embroidery/EmbroiderySneakPeek/LogoSneakPeek'

export const PortalEmbroiderySection: FC = () => {
  const { productColorHex, categoryAnalyticsId, selectedEmbroideryOptions } =
    EmbroideryService.useContainer()
  const { hasMandatoryLogoEmbroidery } = useOrganization()

  const logoSneakPeekBackgroundColor = hashPrefixed(productColorHex)

  const {
    embroidery: { logoTitle },
  } = useTranslation()

  const title = (
    <EmbroiderySectionTitle isRequired={hasMandatoryLogoEmbroidery({ categoryAnalyticsId })}>
      {logoTitle}
    </EmbroiderySectionTitle>
  )

  return (
    <EmbroiderySectionWrapper data-testid='portal-embroidery-section'>
      <AttributeSection title={title}>
        <LogoSneakPeek
          backgroundColor={logoSneakPeekBackgroundColor}
          imgSrc={selectedEmbroideryOptions.LOGO_ONLY?.logoImageSource}
          logoName={selectedEmbroideryOptions.LOGO_ONLY?.logoName}
          logoPlacement={selectedEmbroideryOptions?.LOGO_ONLY?.logoPlacement}
        />
      </AttributeSection>
    </EmbroiderySectionWrapper>
  )
}
